import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {SpinnerOverlayService} from '../services/spinner.service';
import {errorMessageByStatus} from '../shared/utils/error-status-handler';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {
  constructor(
    private spinner: SpinnerOverlayService,
    private notifier: ToastrService
  ) {}
  private apiURL = environment.API;
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.spinner.setLoading(true, request.url);
    return next.handle(request).pipe(
      tap<HttpEvent<any>>((evt: HttpEvent<any>) => {
        if (request.url.includes(this.apiURL)) {
          if (evt instanceof HttpResponse) {
            this.spinner.setLoading(false, request.url);
          }
        }
        return evt;
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = errorMessageByStatus(error);
        this.spinner.setLoading(false, request.url);
        this.notifier.error(errorMsg);
        return throwError(() => error);
      })
    );
  }
}
